import { Image } from 'antd';
import satellite from '../../res/img/login/satelite.png';
import LoginForm from '../../components/Organisms/CommonForm/CommonForm';
import './Login.less';
/**
 * @component Login.tsx
 * @description Component for the invap login.
 * @return { Component }
 */
function Login() {
  return (
    <div className="org-login__container">
      <div className="org-login__left-half">
        <div className="org-navbar-logo" />
        <Image width={400} src={satellite} preview={false} className="org-login__image" />
      </div>
      <div className="org-login__right-half">
        <LoginForm isRegister={false} forgotPassword={false} successMessage={()=>{}} />
      </div>
    </div>
  );
}

export default Login;
